export default "__VITE_ASSET__DJafxgf6__"